import { DependencyList, useEffect } from 'react'

export const useInterval = (callback: () => void, delay = 1000, deps: DependencyList = []): void => {
    useEffect((): () => void => {
        const tick = (): void => callback()

        const interval = setInterval(tick, delay)

        return (): void => clearInterval(interval)
    }, deps)
}
